import {
    Component,
    OnInit,
    Input,
    OnChanges,
    SimpleChange,
    OnDestroy,
} from '@angular/core';
import {
    NavController,
    NavParams,
    App,
    ModalController,
    Events,
    LoadingController,
    Platform,
} from 'ionic-angular';
import { MatchmakingProvider } from '../../providers/matchmaking/matchmaking';
import { CurrentEventProvider } from '../../providers/current-event/current-event';
import { Api } from './../../providers/api/api';
import { User } from './../../providers/user/user';
import { GlobalNotificationsProvider } from '../../providers/providers';
import { MyEvent } from './../../models/event.model';
import { GeoFenceProvider } from './../../providers/geo-fence/geo-fence';
import { Diagnostic } from '@ionic-native/diagnostic';
import { Observable } from 'rxjs';
import { OpenNativeSettings } from '@ionic-native/open-native-settings';
import { LocationAccuracy } from '@ionic-native/location-accuracy';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
/**
 * Generated class for the MatchmakingComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'matchmaking',
    templateUrl: 'matchmaking.html',
})
export class MatchmakingComponent implements OnDestroy {
    contacts: any[] = [];
    eventId: any;
    eventPin: number;
    page = 0;
    pageSize = 20;
    totalPages: number = 0;
    showInvisibeMsg: boolean = false;
    showLocationMsg: boolean = false;
    showPastMsg: boolean = false;
    notOnLocation: boolean = false;
    interval: any;


    @Input('search')
    search: string = '';
    @Input('refresh')
    refresh;
    @Input('init')
    init;

    clickSub$: any;

    constructor(
        private app: App,
        private navCtrl: NavController,
        private navParams: NavParams,
        private api: Api,
        public events: Events,
        public modalCtrl: ModalController,
        private matchmakingProvider: MatchmakingProvider,
        private currentEventProvider: CurrentEventProvider,
        private globalNotificationsProvider: GlobalNotificationsProvider,
        public loadingCtrl: LoadingController,
        public geoLocation: GeoFenceProvider,
        private diagnostic: Diagnostic,
        private platform: Platform,
        private openNativeSettings: OpenNativeSettings,
        private locationAccuracy: LocationAccuracy,
        private userProvider: User,
        private analyticsProvider: AnalyticsProvider
    ) {

    }

    ngAfterViewInit(): void {
        this.checkLocation();
        this.interval = Observable.interval(5000).subscribe(() => {
            this.checkLocation();
        });
    }

    ngOnDestroy() {
        console.log("Mathcmaking destroyed.")
        this.interval.unsubscribe();
        this.clickSub$.unsubscribe();
    }

    ngOnChanges() {
        this.getMatch(this.currentEventProvider.selectedEvent.uuid, this.search);
    }

    ngOnInit() {
        console.log("Matchmaking init");
        let selectedEvent = this.currentEventProvider.selectedEvent;
        this.eventId = selectedEvent.uuid;
        this.eventPin = selectedEvent.pin;
        this.showPastMsg = this.isEventPassed(selectedEvent.eventPastCurrentUpcomingValue);
        this.contacts = [];
        this.totalPages = 0;
        console.log('Loading matchmaking list for event', selectedEvent.pin)
        this.getMatch(selectedEvent.uuid, '');

        this.clickSub$ = this.currentEventProvider.subscribeToTabClick((navData: { segment: any; }) => {
            console.log("Tab click subscription: " + navData.segment);
            if (navData.segment == 'all') {
                this.getMatch(selectedEvent.uuid, '');
            }
        });

        // track page view
        this.analyticsProvider.trackScreenView('Matchmaking - Find Match', selectedEvent.pin, selectedEvent.name);
    }

    getMatch(eventId: string, query: string): void {
        this.page = 0;
        this.contacts = [];
        this.notOnLocation = false;
        this.matchmakingProvider
            .getEventUsersPaginated(eventId, query, this.page, this.pageSize)
            .subscribe(
                (response: any) => {
                    if (response.data.length > 0) {
                        this.showInvisibeMsg = false;
                        this.contacts = response.data;
                        this.totalPages = response.totalPages;
                    } else {
                        if (this.totalPages === 0) {
                            this.contacts = [];
                        }
                        this.matchmakingProvider
                            .checkUserStatus(this.eventPin)
                            .subscribe(res => {
                                this.showInvisibeMsg = res.visible ? false : true;
                            });
                    }
                },
                error => {
                    if (error.error.code === 409) {
                        this.notOnLocation = true;
                        this.contacts = [];
                        this.totalPages = 0;
                    }
                    console.log('NOT ON LOCATION', error);
                });
    }

    viewMessages(userId: string): void {
        this.app.getRootNav().push('MessagePage', {
            userId: userId,
        });
    }

    viewProfile(userId: string): void {
        if ( userId !== this.userProvider.currentUser().uuid) {
            this.app.getRootNav().push('ProfilePage', {
                userId: userId,
                event: this.eventId,
            });
        }
    }

    sendContactRequest(userId: string): void {
        let contactModal = this.modalCtrl.create('SendContactRequestPage', {
            userId: userId,
        });
        contactModal.onDidDismiss(data => {
            for (var i in this.contacts) {
                if (this.contacts[i].uuid == data) {
                    this.contacts[i].hasReceivedPendingRequest = true;
                    break;
                }
            }
        });
        contactModal.present();
    }

    addNote(contact: any): void {
        this.app.getRootNav().push('NotePage', {
            user: contact,
        });
    }

    doInfinite(infiniteScroll) {
        if (this.totalPages > this.page) {
            this.page++;
        }
        setTimeout(() => {
            this.matchmakingProvider
                .getEventUsersPaginated(
                    this.eventId,
                    this.search,
                    this.page,
                    this.pageSize
                )
                .subscribe(res => {
                    this.contacts.push(...res.data);
                    this.totalPages = res.totalPages;
                    infiniteScroll.complete();
                });
        }, 0);
    }

    shortTitle(element): number {
        let height = element.offsetHeight;
        return height;
    }

    profileOnEvent() {
        this.app.getRootNav().push('MatchmakingProfileSettingsPage', {});
    }

    gpsSettings() {
        this.openNativeSettings.open('location').then();
    }

    goToContacts(): void {
        this.events.publish('segment', 'contacts');
        this.currentEventProvider.setCurrentSegment('contacts');
    }

    isEventPassed(eventStatus) {
        return eventStatus === 'PAST';
    }

    checkLocation() {
        this.platform.ready().then((readySource) => {
            if (this.platform.is('cordova')) {
                this.diagnostic.isLocationEnabled().then(
                    (res) => {
                        console.log('Is available? ' + res);
                        this.showLocationMsg = res ? false : true;
                    }).catch((e) => {
                        console.log('LOCATION ERROR', e);
                    });
                this.locationAccuracy.canRequest().then((canRequest: boolean) => {
                    if (canRequest) {
                        // the accuracy option will be ignored by iOS
                        this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
                            () => console.log('Request successful'),
                            error => console.log('Error requesting location permissions', error)
                        );
                    }

                });
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/components/matchmaking/matchmaking.ts